import React from 'react';
import {Link} from 'react-router-dom'

const ChatBots = () => {
  return (
    <section id="chat-bots" className="py-16 bg-gradient-to-br from-purple-600 to-indigo-800">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            CHAT BOTS
          </h2>
          <p className="text-purple-100 text-lg max-w-3xl mx-auto">
            Smart Chatbots - Automate & Monetize Conversations
          </p>
        </div>

        {/* Chat Bots Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/ChatBot.png" 
                alt="AI Chatbot Service" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-indigo-600 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                <span className="animate-pulse mr-2">⚡</span> AI-POWERED
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Boost engagement and revenue with AI-powered chatbots - no coding needed!
              </h3>
              <p className="text-indigo-600 font-semibold mb-4 text-lg">
                Automate customer support, sales, and marketing while unlocking new revenue streams
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Infinity Tech Africa's <strong>Chatbot Service</strong> helps businesses automate interactions across multiple platforms. 
                From instant responses to payment collections, our chatbots work on <strong>WhatsApp, SMS, Facebook, and more</strong> - 
                seamlessly integrating with your PSMS for effortless monetization.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose Our Chatbot Solution?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>24/7 Automation</strong> - Instant replies, order processing, and lead generation.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Monetization Ready</strong> - Collect payments via PSMS, mobile money, or cards.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Multi-Platform</strong> - Deploy on WhatsApp, SMS, social media, and websites.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Easy Setup</strong> - No technical skills required; customizable for your needs.</span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Perfect for:</h4>
                <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-4 border border-indigo-100">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Customer support & FAQs <em>(instant responses)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>E-commerce & order tracking <em>(status updates)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Lead generation & surveys</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Paid content & subscriptions <em>(linked with PSMS)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-indigo-600 font-semibold mb-6 text-center text-lg flex justify-center items-center">
                <span className="mr-2">Turn conversations into conversions - intelligently!</span>
                <span className="text-2xl">🚀</span>
              </p>

              <Link
                to="/contact"  // Make sure this matches your registration route
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Let's Build Your Smart Chatbot Today</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Automate Your Business Communications?
            </h3>
            <p className="text-purple-100 mb-6 text-lg">
              Join forward-thinking businesses enhancing customer experience and revenue with our AI chatbots
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                          <Link
                            to="/contact"
                            className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                          >
                            Contact Our Team
                          </Link>
                          {/* <Link
                            to="/contact"
                            className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                          >
                            Get Started
                          </Link> */}
                        </div>
                        <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa. Create. Transform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChatBots;